(function () {
  'use strict';

  // ── CONFIG ────────────────────────────────────────────────────
  var CONFIG = {
    maxChars: 10,
    workerUrl: 'https://icecity-nameplate.icecity-jewelers12.workers.dev',
    cloudinaryCloudName:    'dbej1s1ia',
    cloudinaryUploadPreset: 'namelpate_preview',
    watermarkText:      'ICECITY_JEWELERS',
    watermarkFontSize:  120,
    watermarkBold:      true,
    watermarkOpacity:   0.25,
    watermarkAngleDeg:  -28
  };

  var LOADER_PHASES = [
    {
      main: 'RENDERING THE ICE\u2026',
      subs: ['Setting up the frame', 'Locking your letters', 'Sculpting the depth']
    },
    {
      main: 'ICING EVERY LETTER\u2026',
      subs: ['Applying emerald frost', 'Setting every facet', 'Making it hit']
    },
    {
      main: 'COLD DROP INCOMING\u2026',
      subs: ['Prepping the reveal', 'Almost cold-dropped', "Ice City's about to drop"]
    }
  ];

  // ── FONTS (5 total) ──────────────────────────────────────────
  var FONTS = [
    { id: 'alex-brush',   name: 'Alex Brush',              family: "'Alex Brush', cursive",          style: 'brush handwritten' },
    { id: 'great-vibes',  name: 'Great Vibes',             family: "'Great Vibes', cursive",         style: 'flowing elegant' },
    { id: 'parisienne',   name: 'Parisienne',              family: "'Parisienne', cursive",          style: 'ornate classic' },
    { id: 'allura',       name: 'Allura',                  family: "'Allura', cursive",              style: 'delicate refined' },
    { id: 'petit-formal', name: 'Petit Formal Script',     family: "'Petit Formal Script', cursive", style: 'formal elegant' }
  ];

var FONT_PROMPT_STYLES = {
    'alex-brush':
      'a bold brush-calligraphy cursive script with strong contrast between thick downstrokes and thin upstrokes, as if painted with a wide flat brush; letters lean forward at a steep slant and connect in continuous flowing loops with minimal lifting, giving it an energetic, confident, hand-painted signature quality',
    'great-vibes':
      'an elegant, high-contrast flowing cursive script with long delicate connecting strokes between letters; tall looping ascenders and descenders extend gracefully above and below the main letter body, with a light, airy, romantic quality reminiscent of formal wedding calligraphy',
    'parisienne':
      'an ornate, classic cursive script with decorative curling flourishes at the start and end of words; letters have rounded, bubbly forms with moderate stroke-width contrast, tightly spaced loops, and a vintage French-postcard character',
    'allura':
      'a delicate, refined cursive script with thin, slender, uniform strokes and minimal contrast between thick and thin; letters are gracefully looped but restrained rather than ornate, with a light forward slant and an airy, understated elegance',
    'petit-formal':
      'a formal, controlled calligraphic cursive script with even, moderate stroke weight and tight, precise closed loops; letters sit nearly upright with only a slight slant, joined smoothly with minimal flourish, giving it a polished, formal invitation-style quality'
  };

  // ── HOLDERS (14 total) ───────────────────────────────────────
  var HOLDERS = [
    { id: 'default',     name: 'Default',           icon: '\u25CB',       promptDesc: 'a simple rounded loop bail at the top-center for a chain to pass through' },
    { id: 'heart',       name: 'Heart',             icon: '\u2764\uFE0F', promptDesc: 'a puffed 3D heart bail charm' },
    { id: 'butterfly',   name: 'Butterfly',         icon: '\uD83E\uDD8B', promptDesc: 'a puffed 3D butterfly bail charm' },
    { id: 'moneybag',    name: 'Money Bag',         icon: '\uD83D\uDCB0', promptDesc: 'a cinched money bag charm with a dollar sign engraved on the front' },
    { id: 'stethoscope', name: 'Stethoscope Heart', icon: '\uD83E\uDE7A', promptDesc: 'a medical stethoscope twisted into a heart shape charm' },
    { id: 'barbie',      name: 'Barbie Head',       icon: '\uD83D\uDC69', promptDesc: 'a side-profile silhouette of a classic woman head with a high ponytail' },
    { id: 'crown',       name: 'Crown',             icon: '\uD83D\uDC51', promptDesc: 'a 5-point royal crown charm with small spheres on the tips' },
    { id: 'star',        name: 'Star',              icon: '\u2B50',       promptDesc: 'a sharp symmetrical 5-point star charm' },
    { id: 'flower',      name: 'Four-Leaf Clover',  icon: '\uD83C\uDF40', promptDesc: 'a detailed four-leaf clover charm with raised center vein and rounded petals' },
    { id: 'diamond',     name: 'Diamond',           icon: '\uD83D\uDC8E', promptDesc: 'a brilliant-cut multi-faceted diamond gemstone charm' },
    { id: 'goat',        name: 'Goat',              icon: '\uD83D\uDC10', promptDesc: 'a stylized goat head silhouette charm' },
    { id: 'hellokitty',  name: 'Hello Kitty',       icon: '\uD83D\uDC31', promptDesc: 'a cute cartoon cat head charm with a distinct bow on the left ear' },
    { id: 'key',         name: 'Key',               icon: '\uD83D\uDD11', promptDesc: 'a vintage skeleton key charm' },
    { id: 'snowflake',   name: 'Snowflake',         icon: '\u2744\uFE0F', promptDesc: 'a symmetrical six-pointed snowflake charm with delicate branching facets' }
  ];

  // ── STATE ─────────────────────────────────────────────────────
  var state = {
    name: '', font: FONTS[0], holder: HOLDERS[0],
    previewDataUrl: null,
    isGenerating: false, isAdding: false
  };

  var dom = {};
  var phaseTimer = null;
  var subTimer = null;
  var progressAnimFrame = null;
  var currentPhase = 0;
  var currentSubIdx = 0;

  // ── INIT ──────────────────────────────────────────────────────
  function init() {
    dom.overlay           = document.getElementById('np-overlay');
    dom.nameInput         = document.getElementById('np-name-input');
    dom.charCount         = document.getElementById('np-char-count');
    dom.fontPicker        = document.getElementById('np-font-picker');
    dom.fontTrigger       = document.getElementById('np-font-trigger');
    dom.fontTriggerPrev   = document.getElementById('np-font-trigger-preview');
    dom.fontDropdown      = document.getElementById('np-font-dropdown');
    dom.holderPicker      = document.getElementById('np-holder-picker');
    dom.holderTrigger     = document.getElementById('np-holder-trigger');
    dom.holderTriggerIcon = document.getElementById('np-holder-trigger-icon');
    dom.holderTriggerName = document.getElementById('np-holder-trigger-name');
    dom.holderDropdown    = document.getElementById('np-holder-dropdown');
    dom.generateBtn       = document.getElementById('np-generate-btn');
    dom.generateLabel     = document.getElementById('np-generate-label');
    dom.previewEmpty      = document.getElementById('np-preview-empty');
    dom.aiLoader          = document.getElementById('np-ai-loader');
    dom.loaderText        = document.getElementById('np-loader-text');
    dom.loaderMain        = document.getElementById('np-loader-main');
    dom.loaderLineFill    = document.getElementById('np-loader-line-fill');
    dom.loaderProgressFill= document.getElementById('np-loader-progress-fill');
    dom.loaderSteps = [
      document.getElementById('np-loader-step-1'),
      document.getElementById('np-loader-step-2'),
      document.getElementById('np-loader-step-3')
    ];
    dom.aiImage           = document.getElementById('np-ai-image');
    dom.previewBadge      = document.getElementById('np-preview-badge');
    dom.addBtn            = document.getElementById('np-add-btn');
    dom.errorMsg          = document.getElementById('np-error');
    dom.summaryFont       = document.getElementById('nds-summary-font');
    dom.summaryHolder     = document.getElementById('nds-summary-holder');

    if (!dom.overlay) return;

    buildFontPicker();
    buildHolderPicker();
    addFontDisclaimer();
    bindEvents();
    updateSummary();
  }

  // ── FONT DISCLAIMER ───────────────────────────────────────────
  // Sets honest expectations: the picker shows the FONT STYLE, but the
  // actual pendant is AI-rendered per order, so exact pixel-for-pixel
  // match to the picker preview isn't guaranteed. Injected via JS so no
  // template/HTML file edit is needed — just needs the font picker's
  // existing DOM id, which is already referenced elsewhere in this file.
  function addFontDisclaimer() {
    if (!dom.fontPicker || dom.fontPicker.parentNode.querySelector('.np-font-disclaimer')) return;
    var note = document.createElement('p');
    note.className = 'np-font-disclaimer';
    note.textContent = 'Preview shows font style — your piece is individually AI-rendered for a one-of-a-kind emerald finish.';
    note.style.cssText = 'font-size:12px;color:#8a8a8a;margin-top:8px;line-height:1.4;';
    dom.fontPicker.parentNode.insertBefore(note, dom.fontPicker.nextSibling);
  }

  // ── PHASE-BASED LOADER ────────────────────────────────────────
  function startPhaseLoader() {
    currentPhase = 0;
    currentSubIdx = 0;
    setLoaderPhase(0);

    phaseTimer = setInterval(function () {
      currentPhase = (currentPhase + 1) % LOADER_PHASES.length;
      currentSubIdx = 0;
      setLoaderPhase(currentPhase);
    }, 3000);

    subTimer = setInterval(function () {
      currentSubIdx++;
      updateLoaderSub();
    }, 1500);

    animateProgressBar(0, 100, 9000);
  }

  function stopPhaseLoader() {
    if (phaseTimer) { clearInterval(phaseTimer); phaseTimer = null; }
    if (subTimer)   { clearInterval(subTimer); subTimer = null; }
    if (progressAnimFrame) { cancelAnimationFrame(progressAnimFrame); progressAnimFrame = null; }
  }

  function setLoaderPhase(idx) {
    if (!dom.loaderSteps) return;
    dom.loaderSteps.forEach(function (el, i) {
      if (!el) return;
      el.classList.remove('active', 'done');
      if (i < idx) el.classList.add('done');
      if (i === idx) el.classList.add('active');
    });
    if (dom.loaderLineFill) {
      var lineWidth = idx === 0 ? 0 : (idx === 1 ? 35 : 70);
      dom.loaderLineFill.style.width = lineWidth + '%';
    }
    if (dom.loaderMain) {
      dom.loaderMain.style.opacity = '0';
      dom.loaderMain.style.transform = 'translateY(4px)';
      setTimeout(function () {
        dom.loaderMain.textContent = LOADER_PHASES[idx].main;
        dom.loaderMain.style.opacity = '1';
        dom.loaderMain.style.transform = 'translateY(0)';
      }, 200);
    }
    currentSubIdx = 0;
    updateLoaderSub();
  }

  function updateLoaderSub() {
    if (!dom.loaderText) return;
    var phase = LOADER_PHASES[currentPhase];
    if (!phase) return;
    var subMsg = phase.subs[currentSubIdx % phase.subs.length];
    dom.loaderText.style.opacity = '0';
    setTimeout(function () {
      dom.loaderText.textContent = subMsg;
      dom.loaderText.style.opacity = '1';
    }, 150);
  }

  function animateProgressBar(from, to, duration) {
    if (!dom.loaderProgressFill) return;
    var start = performance.now();
    function frame(now) {
      var elapsed = now - start;
      var t = Math.min(elapsed / duration, 1);
      var value = from + (to - from) * t;
      if (dom.loaderProgressFill) {
        dom.loaderProgressFill.style.width = value + '%';
      }
      if (t < 1) progressAnimFrame = requestAnimationFrame(frame);
    }
    progressAnimFrame = requestAnimationFrame(frame);
  }

  // ── FONT PICKER ───────────────────────────────────────────────
  function buildFontPicker() {
    dom.fontTriggerPrev.style.fontFamily = state.font.family;
    dom.fontDropdown.innerHTML = '';
    FONTS.forEach(function (f, i) {
      var opt = document.createElement('div');
      opt.className = 'np-font-option' + (i === 0 ? ' is-selected' : '');
      opt.dataset.fontId = f.id;
      opt.innerHTML =
        '<span class="np-font-option__preview" style="font-family:' + f.family + '">' +
          (state.name.trim() || 'Shanelle') + '</span>' +
        '<span class="np-font-option__name">' + f.name + ' \u00b7 ' + f.style + '</span>';
      opt.addEventListener('click', function () { selectFont(f); closeFontDropdown(); });
      dom.fontDropdown.appendChild(opt);
    });
  }

  function selectFont(font) {
    state.font = font; state.previewDataUrl = null;
    dom.fontTriggerPrev.textContent = state.name.trim() || 'Shanelle';
    dom.fontTriggerPrev.style.fontFamily = font.family;
    dom.fontDropdown.querySelectorAll('.np-font-option').forEach(function (el) {
      el.classList.toggle('is-selected', el.dataset.fontId === font.id);
    });
    updateSummary();
    resetPreview();
  }

  function openFontDropdown() {
    var sample = state.name.trim() || 'Shanelle';
    dom.fontDropdown.querySelectorAll('.np-font-option__preview').forEach(function (el) {
      el.textContent = sample;
    });
    closeHolderDropdown();
    dom.fontDropdown.classList.add('is-open');
    dom.fontTrigger.classList.add('is-open');
  }
  function closeFontDropdown() {
    dom.fontDropdown.classList.remove('is-open');
    dom.fontTrigger.classList.remove('is-open');
  }
  function toggleFontDropdown() {
    dom.fontDropdown.classList.contains('is-open') ? closeFontDropdown() : openFontDropdown();
  }

  // ── HOLDER PICKER ─────────────────────────────────────────────
  function buildHolderPicker() {
    dom.holderDropdown.innerHTML = '';
    HOLDERS.forEach(function (h, i) {
      var opt = document.createElement('div');
      opt.className = 'np-holder-option' + (i === 0 ? ' is-selected' : '');
      opt.dataset.holderId = h.id;
      opt.innerHTML =
        '<span class="np-holder-option__icon">' + h.icon + '</span>' +
        '<span class="np-holder-option__name">' + h.name + '</span>';
      opt.addEventListener('click', function () { selectHolder(h); closeHolderDropdown(); });
      dom.holderDropdown.appendChild(opt);
    });
  }

  function selectHolder(holder) {
    state.holder = holder; state.previewDataUrl = null;
    dom.holderTriggerIcon.textContent = holder.icon;
    dom.holderTriggerName.textContent = holder.name;
    dom.holderDropdown.querySelectorAll('.np-holder-option').forEach(function (el) {
      el.classList.toggle('is-selected', el.dataset.holderId === holder.id);
    });
    updateSummary();
    resetPreview();
  }

  function openHolderDropdown() {
    closeFontDropdown();
    dom.holderDropdown.classList.add('is-open');
    dom.holderTrigger.classList.add('is-open');
  }
  function closeHolderDropdown() {
    dom.holderDropdown.classList.remove('is-open');
    dom.holderTrigger.classList.remove('is-open');
  }
  function toggleHolderDropdown() {
    dom.holderDropdown.classList.contains('is-open') ? closeHolderDropdown() : openHolderDropdown();
  }

  // ── UPDATE SUMMARY ────────────────────────────────────────────
  function updateSummary() {
    if (dom.summaryFont) dom.summaryFont.textContent = state.font.name;
    if (dom.summaryHolder) dom.summaryHolder.textContent = state.holder.name;
  }

  // ── EVENTS ────────────────────────────────────────────────────
  function bindEvents() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (dom.fontDropdown.classList.contains('is-open')) closeFontDropdown();
        else if (dom.holderDropdown.classList.contains('is-open')) closeHolderDropdown();
      }
    });
    document.addEventListener('click', function (e) {
      if (dom.fontPicker && !dom.fontPicker.contains(e.target)) closeFontDropdown();
      if (dom.holderPicker && !dom.holderPicker.contains(e.target)) closeHolderDropdown();
    });
    dom.fontTrigger.addEventListener('click', function (e) { e.stopPropagation(); toggleFontDropdown(); });
    dom.holderTrigger.addEventListener('click', function (e) { e.stopPropagation(); toggleHolderDropdown(); });

    dom.nameInput.addEventListener('input', function () {
      var v = dom.nameInput.value.slice(0, CONFIG.maxChars);
      dom.nameInput.value = v; state.name = v; state.previewDataUrl = null;
      dom.charCount.textContent = v.length + ' / ' + CONFIG.maxChars + ' characters';
      dom.fontTriggerPrev.textContent = v || 'Shanelle';
      clearError();
      checkGenerateBtn();
      resetPreview();
    });

    dom.generateBtn.addEventListener('click', generatePreview);
    dom.addBtn.addEventListener('click', handleAddToCart);
  }

  function resetPreview() {
    dom.aiImage.style.display = 'none';
    dom.aiImage.src = '';
    dom.addBtn.disabled = true;
    state.previewDataUrl = null;
    if (dom.previewBadge) {
      dom.previewBadge.classList.remove('is-generating', 'is-ready');
      dom.previewBadge.querySelector('span:not(.nds-preview-dot)').textContent = 'Awaiting input';
    }
    if (dom.previewEmpty) dom.previewEmpty.style.display = 'flex';
  }

  function checkGenerateBtn() {
    dom.generateBtn.disabled = !state.name.trim() || state.isGenerating;
  }

  // ── WATERMARK (client-side, canvas-based) ──────────────────────
  // Draws the generated preview onto an offscreen canvas, then stamps
  // tiled, rotated, semi-transparent "icecity_jewelers" text on top
  // before it's shown to the customer. Uses Promise chaining (not
  // async/await) to match the rest of this file's style. No external
  // image to load, so there's nothing to fail here except the base
  // image itself — in that unlikely case it falls back to the
  // unwatermarked image rather than blocking the preview.
  function applyIceCityWatermark(base64Png) {
    return new Promise(function (resolve) {
      var baseImg = new Image();
      baseImg.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = baseImg.naturalWidth;
        canvas.height = baseImg.naturalHeight;
        var ctx = canvas.getContext('2d');

        // 1. Draw the original generated image
        ctx.drawImage(baseImg, 0, 0);

        // 2. Stamp tiled, rotated watermark text on top
        ctx.save();
        ctx.globalAlpha = CONFIG.watermarkOpacity;
        ctx.fillStyle = '#ffffff';
        ctx.font = (CONFIG.watermarkBold ? 'bold ' : '') + CONFIG.watermarkFontSize + 'px sans-serif';
        ctx.textBaseline = 'middle';

        var textWidth = ctx.measureText(CONFIG.watermarkText).width;
        var spacingX = textWidth + 60;
        var spacingY = CONFIG.watermarkFontSize * 3;

        var diag = Math.sqrt(canvas.width * canvas.width + canvas.height * canvas.height);
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((CONFIG.watermarkAngleDeg * Math.PI) / 180);
        ctx.translate(-diag / 2, -diag / 2);

        for (var y = 0; y < diag + spacingY; y += spacingY) {
          for (var x = 0; x < diag + spacingX; x += spacingX) {
            ctx.fillText(CONFIG.watermarkText, x, y);
          }
        }
        ctx.restore();

        // 3. Return the watermarked image as a new base64 PNG
        resolve(canvas.toDataURL('image/png').split(',')[1]);
      };
      baseImg.onerror = function (e) {
        console.warn('Watermarking failed, showing unwatermarked preview:', e);
        resolve(base64Png);
      };
      baseImg.src = 'data:image/png;base64,' + base64Png;
    });
  }

  // ── GENERATE PREVIEW ─────────────────────────────────────────
  function generatePreview() {
    if (!state.name.trim() || state.isGenerating) return;

    state.isGenerating = true;
    state.previewDataUrl = null;

    dom.previewEmpty.style.display = 'none';
    dom.aiImage.style.display = 'none';
    dom.aiImage.src = '';
    dom.aiLoader.style.display = 'flex';
    dom.generateBtn.disabled = true;
    dom.generateLabel.textContent = 'Generating\u2026';
    dom.addBtn.disabled = true;

    if (dom.previewBadge) {
      dom.previewBadge.classList.add('is-generating');
      dom.previewBadge.classList.remove('is-ready');
      dom.previewBadge.querySelector('span:not(.nds-preview-dot)').textContent = 'Generating';
    }

    startPhaseLoader();

    // ── Simple JSON request to worker ──
var requestPayload = {
      plateType: 'double',
      name:       state.name,
      font:       state.font.name,
      fontDesc:   FONT_PROMPT_STYLES[state.font.id] || state.font.description,
      holder:     state.holder.name,
      holderDesc: state.holder.promptDesc
    };

    console.log('SENDING TO WORKER:', requestPayload);

    fetch(CONFIG.workerUrl, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestPayload)
    })
      .then(function (r) {
        console.log('WORKER STATUS:', r.status);
        return r.text().then(function (text) {
          console.log('WORKER RAW RESPONSE:', text);
          if (!r.ok) {
            throw new Error('Worker ' + r.status + ': ' + text);
          }
          try {
            return JSON.parse(text);
          } catch (e) {
            throw new Error('Invalid JSON from worker: ' + text.substring(0, 200));
          }
        });
      })
      .then(function (data) {
        if (data.error) throw new Error(data.error);

        var partsArr = data && data.candidates && data.candidates[0] &&
                       data.candidates[0].content && data.candidates[0].content.parts;
        var b64 = null;
        if (partsArr) {
          for (var i = 0; i < partsArr.length; i++) {
            var d = partsArr[i].inlineData || partsArr[i].inline_data;
            if (d && d.data) { b64 = d.data; break; }
          }
        }
        if (!b64) throw new Error('No image returned');

        return applyIceCityWatermark(b64);
      })
      .then(function (watermarkedB64) {
        var dataUrl = 'data:image/png;base64,' + watermarkedB64;
        stopPhaseLoader();
        state.isGenerating = false;
        state.previewDataUrl = dataUrl;

        dom.aiLoader.style.display = 'none';
        dom.aiImage.src = dataUrl;
        dom.aiImage.style.display = 'block';
        dom.generateBtn.disabled = false;
        dom.generateLabel.textContent = 'Regenerate';
        dom.addBtn.disabled = false;

        if (dom.previewBadge) {
          dom.previewBadge.classList.remove('is-generating');
          dom.previewBadge.classList.add('is-ready');
          dom.previewBadge.querySelector('span:not(.nds-preview-dot)').textContent = 'Ready';
        }
      })
      .catch(function (err) {
        stopPhaseLoader();
        state.isGenerating = false;
        dom.aiLoader.style.display = 'none';
        dom.previewEmpty.style.display = 'flex';
        dom.generateBtn.disabled = false;
        dom.generateLabel.textContent = 'Generate Preview';
        showError('Generation failed. Please try again.');
        console.error('Generation error:', err);

        if (dom.previewBadge) {
          dom.previewBadge.classList.remove('is-generating', 'is-ready');
          dom.previewBadge.querySelector('span:not(.nds-preview-dot)').textContent = 'Awaiting input';
        }
      });
  }

  // ── CLOUDINARY UPLOAD ─────────────────────────────────────────
  function uploadPreview() {
    return new Promise(function (resolve) {
      if (!CONFIG.cloudinaryCloudName ||
          CONFIG.cloudinaryCloudName === 'YOUR_CLOUD_NAME' ||
          !state.previewDataUrl) {
        resolve(state.previewDataUrl || null);
        return;
      }
      var fd = new FormData();
      fd.append('file', state.previewDataUrl);
      fd.append('upload_preset', CONFIG.cloudinaryUploadPreset);
      fd.append('folder', 'nameplate-previews/double');
      fetch('https://api.cloudinary.com/v1_1/' + CONFIG.cloudinaryCloudName + '/image/upload',
        { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (d) { resolve(d.secure_url || null); })
        .catch(function () { resolve(null); });
    });
  }

  // ── ADD TO CART ───────────────────────────────────────────────
  function handleAddToCart() {
    clearError();
    if (!state.name.trim()) {
      showError('Please enter a name for your nameplate.');
      dom.nameInput.focus(); return;
    }
    var variantId = getVariantId();
    if (!variantId) {
      showError('Could not find the product. Please visit the product page.');
      return;
    }
    setLoading(true);
    uploadPreview().then(function (imageUrl) {
      var props = {
        'Plate Type':     'Double Plate',
        'Nameplate Text': state.name,
        'Font Style':     state.font.name,
        'Holder Charm':   state.holder.name
      };
      if (imageUrl) props['Preview Image'] = imageUrl;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
      });
    })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function () {
      setLoading(false);
      if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
      else window.location.href = '/cart';
    })
    .catch(function () {
      setLoading(false);
      showError('Something went wrong. Please try again.');
    });
  }

  function getVariantId() {
    var sel = document.querySelector('select[name="id"], input[name="id"]:checked, input[name="id"]');
    if (sel && sel.value) return parseInt(sel.value, 10);
    if (window.__NAMEPLATE_VARIANT_ID__) return parseInt(window.__NAMEPLATE_VARIANT_ID__, 10);
    return null;
  }

  function setLoading(b) {
    state.isAdding = b;
    dom.addBtn.disabled = b;
    dom.addBtn.classList.toggle('is-loading', b);
  }
  function showError(msg) { dom.errorMsg.textContent = msg; dom.errorMsg.classList.add('is-visible'); }
  function clearError()   { dom.errorMsg.classList.remove('is-visible'); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();